/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrServiceUserType = 'UNKNOWN_TYPE' | 'ROLE' | 'SERVICE_ACCOUNT';

export const IrrServiceUserType = {

    UNKNOWN_TYPE: 'UNKNOWN_TYPE' as IrrServiceUserType,

    ROLE: 'ROLE' as IrrServiceUserType,

    SERVICE_ACCOUNT: 'SERVICE_ACCOUNT' as IrrServiceUserType
};

